import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function paginationContainer(theme: Theme): ComponentStyle {
  return {
    componentName: 'paginationContainer',
    baseStyle: {
      paddingLeft: theme.space['xs'],
      paddingRight: theme.space['xs']
    }
  };
}
